let stripeInstance = null

export default function getStripe() {
  if (stripeInstance === null) {
    stripeInstance = global.Stripe(process.env.STRIPE_PUB)
  }
  return stripeInstance
}
